export enum BugCategoryType {
  None = 0,
  CreditLost = 1,
  BuyIssue = 2,
  InGameIssue = 3,
  GameIssue = 4,
  Other = 5
}
